export default __webpack_public_path__ + "static/media/roadmap_2.02d3217e.jpg";